import React from 'react'
import { Query } from 'react-apollo'
import { Creatable } from 'react-select'
import interessi from 'graphql/queries/interessi'

const InteressiField = ({ input: { onChange, value }}) => {
  return (
    <Query query={interessi} fetchPolicy="cache-and-network">
      {({ loading, error, data }) => {
        if (loading) return <p>Caricamento interessi...</p>
        if (error) return <p>Errore :(</p>

        return (
          <Creatable
            multi={true}
            options={data.allInteressi.map(interesse => ({
              value: interesse.nome,
              label: interesse.nome,
            }))}
            value={value}
            //simpleValue={true}
            onChange={onChange}
            placeholder="Seleziona"
            noResultsText="Nessun risultato"
            promptTextCreator={label => `Crea nuovo tag "${label}"`}
          />
        )
      }}
    </Query>
  )
}

export default InteressiField



// WEBPACK FOOTER //
// ./src/views/App/Clienti/InteressiField.jsx